import {
    REQUIRED_EMAIL_VERIFICATION,
    REQUIRED_PHONE_VERIFICATION,
    REQUIRED_PASSWORD_VERIFICATION,
    PASSWORD_PROTECTION,
} from '@/consts';
import { Policy, PolicySettingsAll } from '../../types/types';
import { UploadedItem } from '../../stores';

export const checkIsPhoneOnlyPolicy = (policySettings: PolicySettingsAll): boolean => {
    const phoneVerificationSetting = policySettings.access?.find(
        ({ id }) => id === REQUIRED_PHONE_VERIFICATION,
    );
    const emailVerificationSetting = policySettings.access?.find(
        ({ id }) => id === REQUIRED_EMAIL_VERIFICATION,
    );
    const hasPhoneVerification = !!phoneVerificationSetting?.value;
    const hasEmailVerification = !!emailVerificationSetting?.value;
    return hasPhoneVerification && !hasEmailVerification;
};

export const checkRequiresPhoneVerification = (policySettings: PolicySettingsAll): boolean => {
    const phoneVerificationSetting = policySettings.access?.find(
        ({ id }) => id === REQUIRED_PHONE_VERIFICATION,
    );
    return !!phoneVerificationSetting?.value;
};

export const checkRequiresPasswordVerification = (policySettings: PolicySettingsAll): boolean => {
    const passwordVerificationSetting = policySettings.access?.find(
        ({ id }) => id === REQUIRED_PASSWORD_VERIFICATION ,
    );
    return !!passwordVerificationSetting?.value;
};

export const checkRequiresPasswordProtection = (policySettings: PolicySettingsAll): boolean => {
    const passwordProtectionSetting = policySettings.access?.find(
        ({ id }) => id === PASSWORD_PROTECTION,
    );
    return !!passwordProtectionSetting?.value;
};

export const checkHasPhoneOnlyPolicyInFilesList = (filesList: UploadedItem[], policiesList: Policy[]): boolean => {
    const policiesMap: Record<string, Policy> = policiesList.reduce(
        (acc, currentValue) => {
            acc[currentValue.id] = currentValue;
            return acc;
        },
        {},
    );
    const filePoliciesIds = [...new Set<string>(filesList.map<string>(({ policy }) => policy?.id))];
    return !!filePoliciesIds.find((policyId) => {
        const settings = policiesMap[policyId]?.settings;
        return settings ? checkIsPhoneOnlyPolicy(settings) : false;
    });
};

export const checkHasPhoneVerificationInFilesList = (filesList: UploadedItem[], policiesList: Policy[]): boolean => {
    const policiesMap: Record<string, Policy> = policiesList.reduce(
        (acc, currentValue) => {
            acc[currentValue.id] = currentValue;
            return acc;
        },
        {},
    );
    const filePoliciesIds = [...new Set<string>(filesList.map<string>(({ policy }) => policy?.id))];
    return !!filePoliciesIds.find((policyId) => {
        const settings = policiesMap[policyId]?.settings;
        return settings ? checkRequiresPhoneVerification(settings) : false;
    });
};

export const checkHasPasswordVerificationInFilesList = (
    filesList: UploadedItem[],
    policiesList: Policy[],
): boolean => {
    const policiesMap: Record<string, Policy> = policiesList.reduce(
        (acc, currentValue) => {
            acc[currentValue.id] = currentValue;
            return acc;
        },
        {},
    );
    const filePoliciesIds = [...new Set<string>(filesList.map<string>(({ policy }) => policy?.id))];
    return !!filePoliciesIds.find((policyId) => {
        const settings = policiesMap[policyId]?.settings;
        return settings ? checkRequiresPasswordVerification(settings) : false;
    });
};

export const checkHasPasswordProtectionInFilesList = (
    filesList: UploadedItem[],
    policiesList: Policy[],
): boolean => {
    const policiesMap: Record<string, Policy> = policiesList.reduce(
        (acc, currentValue) => {
            acc[currentValue.id] = currentValue;
            return acc;
        },
        {},
    );
    const filePoliciesIds = [...new Set<string>(filesList.map<string>(({ policy }) => policy?.id))];
    return !!filePoliciesIds.find((policyId) => {
        const settings = policiesMap[policyId]?.settings;
        return settings ? checkRequiresPasswordProtection(settings) : false;
    });
};
